import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { RouterState, RoutingService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MobileMenuNavigationService {
  constructor(
    private routingService: RoutingService,
    private router: Router,
  ) {}

  isMenuOpened(): Observable<boolean> {
    return this.routingService.getRouterState().pipe(map((state: RouterState) => state.state.url.includes('/menu')));
  }

  openRootLevel(): void {
    this.router.navigate(['/menu'], { queryParamsHandling: 'merge' });
  }

  closeMenu(): void {
    // TODO: Временно так, пока у нас один уровень меню, это будет работать.
    // В рамках мобильного рубрикатора, нужно будет продумать и доработать
    window.history.go(-1);
  }

  toggleMenu(): void {
    this.isMenuOpened()
      .pipe(take(1))
      .subscribe((isOpened: boolean) => (isOpened ? this.closeMenu() : this.openRootLevel()));
  }

  goBack(): void {
    window.history.go(-1);
  }
}
